module.exports = __webpack_public_path__ + "static/media/img1-7.430d51ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/biosense/diff/img1-7.png
// module id = 1978
// module chunks = 3